import request from '@/utils/request'
import URL from './urlTranslator'

export function getWorkFlow(params) {
  return request({
    url: `${URL.workflow.getWorkflow}`,
    method: 'get',
    params
  })
}

export function getUserRoles(params) {
  return request({
    url: `${URL.workflow.getUserRoles}`,
    method: 'get',
    params
  })
}
export function actionProcess(data) {
  return request({
    url: `${URL.workflow.actionProcess}`,
    method: 'post',
    data
  })
}
// 提交审批
export function workflowSubmit(data) {
  return request({
    url: `${URL.workflow.workflowSubmit}`,
    method: 'post',
    data
  })
}
// 获取我发起的列表
export function workflowSelfList(data) {
  return request({
    url: `${URL.workflow.workflowSelfList}`,
    method: 'post',
    data
  })
}
// 获取我处理的列表
export function workflowPendingList(data) {
  return request({
    url: `${URL.workflow.workflowPendingList}`,
    method: 'post',
    data
  })
}
// 根据documentProcessId单据信息
export function getByDocumentProcessId(documentProcessId) {
  return request({
    url: `${URL.workflow.getByDocumentProcessId}`,
    method: 'get',
    params: { documentProcessId }
  })
}
// 获取我的按钮列表
export function workflowCheck(params) {
  return request({
    url: `${URL.workflow.workflowCheck}`,
    method: 'get',
    params
  })
}
// 动作按钮
export function workflowAction(data) {
  return request({
    url: `${URL.workflow.workflowAction}`,
    method: 'post',
    data
  })
}
// 批量动作按钮
export function workflowActionBatch(data) {
  return request({
    url: `${URL.workflow.workflowActionBatch}`,
    method: 'post',
    data
  })
}
// 审核历史
export function workflowHistory(params) {
  return request({
    url: `${URL.workflow.workflowHistory}`,
    method: 'get',
    params
  })
}
// 审核详情
export function getDocumentProcess(params) {
  return request({
    url: `${URL.workflow.getDocumentProcess}`,
    method: 'get',
    params
  })
}
// 审批列表合计
export function manageCount(params) {
  return request({
    url: `${URL.workflow.manageCount}`,
    method: 'get',
    params
  })
}

// 首页待办事项合计
export function manageIndexCount(params) {
  return request({
    url: `${URL.workflow.manageIndexCount}`,
    method: 'get',
    params
  })
}

// 审批流程列表查询
export function configList(data) {
  return request({
    url: `${URL.workflow.configList}`,
    method: 'post',
    data
  })
}
// 审批流程详情
export function configDetail(params) {
  return request({
    url: `${URL.workflow.configDetail}`,
    method: 'get',
    params
  })
}

// 保存审批流程
export function configWorkflow(data) {
  return request({
    url: `${URL.workflow.configWorkflow}`,
    method: 'post',
    data
  })
}
// 审批流程启用禁用
export function configActive(data) {
  return request({
    url: `${URL.workflow.configActive}`,
    method: 'post',
    data
  })
}
// 审批流程启用禁用
export function configCopy(data) {
  return request({
    url: `${URL.workflow.configCopy}`,
    method: 'post',
    data
  })
}
// 获取审批流程规则配置
export function configRule(params) {
  return request({
    url: `${URL.workflow.configRule}`,
    method: 'get',
    params
  })
}
// 表单（eg: 付款申请）平台配置 创建或编辑
export function documentPlatformConfigSave(data) {
  return request({
    url: `${URL.workflow.documentPlatformConfigSave}`,
    method: 'post',
    data
  })
}
// 表单（eg: 付款申请）平台配置 启用禁用
export function documentPlatformConfigActive(data) {
  return request({
    url: `${URL.workflow.documentPlatformConfigActive}`,
    method: 'post',
    data
  })
}
// 表单（eg: 付款申请）平台配置 列表
export function documentPlatformConfigList(data) {
  return request({
    url: `${URL.workflow.documentPlatformConfigList}`,
    method: 'post',
    data
  })
}
// 获取可创建的最大分支流程数量
export function getBranchProcessCountMaxLimit(params) {
  return request({
    url: `${URL.workflow.getBranchProcessCountMaxLimit}`,
    method: 'get',
    params
  })
}
// 获取表单列表
export function getFormList(params) {
  return request({
    url: `${URL.workflow.getFormList}`,
    method: 'get',
    params
  })
}
// 获取表单名称列表
export function workflowGroupNameList(params) {
  return request({
    url: `${URL.workflow.workflowGroupNameList}`,
    method: 'get',
    params
  })
}
// bpm是否开启（是否该分公司、该表单类型存在对应的工作流）(【付款申请单】不走该方法，因为其存在【付款申请（新版）】，新老分开)
export function isBpmEnabled(params) {
  return request({
    url: `${URL.workflow.isBpmEnabled}`,
    method: 'get',
    params
  })
}
// 获取单据信息
export function convertDocument(params) {
  return request({
    url: `${URL.workflow.convertDocument}`,
    method: 'get',
    params
  })
}

// 批量取消
export function batchCancel(data) {
  return request({
    url: `${URL.workflow.batchCancel}`,
    method: 'post',
    data
  })
}
// 获取加签信息
export function getAddSignatureInfo(params) {
  return request({
    url: `${URL.workflow.getAddSignatureInfo}`,
    method: 'get',
    params
  })
}

// 获取委派列表
export function appointList(params) {
  return request({
    url: `${URL.workflow.appointList}`,
    method: 'get',
    params
  })
}

// 批量委派按钮 参数参考workflowActionBatch
export function appointSave(data) {
  return request({
    url: `${URL.workflow.appointSave}`,
    method: 'post',
    data
  })
}

// 工作流是否存在
export function existWorkflowGroup(params) {
  return request({
    url: `${URL.workflow.existWorkflowGroup}`,
    method: 'get',
    params
  })
}
